import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors } from '@angular/forms';
import { isMatch } from 'date-fns';

@Directive({
  selector: '[date-validator]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: DateValidatorDirective,
    multi: true
  }]
})
export class DateValidatorDirective {

  constructor() { }

  validate(control: AbstractControl): ValidationErrors {
    const dateIsValid = isMatch(control.value, 'dd/MM/yyyy');
    return  control?.value?.length > 0 && !dateIsValid ? { invalidDate: true } : null;
  }

}
